import type { SVGProps } from "react";

import "./icons.scss";

export const iconSizes = ["sm", "md", "lg", "xl"] as const;

export type IconSize = (typeof iconSizes)[number];

type IconSvgProps = Omit<SVGProps<SVGSVGElement>, "height" | "style" | "width">;

export interface IconComponentProps extends IconSvgProps {
  readonly size?: IconSize;
}

const defaultIconDimension = 16;

export const getIconClassName = (className?: string): string => {
  const classes = ["cnc-icon-component"];

  if (className) {
    classes.push(className);
  }

  return classes.join(" ");
};

export const getIconDimension = (size?: IconSize): number => {
  switch (size) {
    case "sm":
      return 12;
    case "md":
      return 16;
    case "lg":
      return 20;
    case "xl":
      return 24;
    case undefined:
    default:
      return defaultIconDimension;
  }
};
